export default __webpack_public_path__ + "static/scic-8f47b87a8488690a6c7901a8cbfcf87d.png";